import React from "react";
import { Header, Segment, Input, Icon } from "semantic-ui-react";
import firebase from "../../firebase";
import { connect } from "react-redux";
import { setCurrentChannel, setPrivateChannel } from "../../actions";
import { Menu, Modal, Form, Button, Label } from "semantic-ui-react";

class MessagesHeaderChannel extends React.Component {
  state = {
    activeChannel: "",
    user: this.props.currentUser,
    channel: null,
    channels: [],
    channelName: "",
    channelDetails: "",
    channelsRef: firebase.database().ref("channels"),
    messagesRef: firebase.database().ref("messages"),
    typingRef: firebase.database().ref("typing"),
    hashTagRef: firebase.database().ref("hasTag"),
    userRef: firebase.database().ref(`users/${this.props.currentUser.uid}`),
    notifications: [],
    modal: false,
    firstLoad: true,
    //親子チャンネル
    parentChannelsRef: firebase.database().ref("parent_channels"),
    parentChannels: [],
    hashTags: [],
    secretCode: "",
    presenceChannelRef: firebase.database().ref("presenceChannel"),
    previousChannel: "",
    isMounted: false,
    myData: ""
  };

  componentDidMount() {
    this.state.isMounted = true;

    //秘密の部屋コード
    this.state.userRef.on("value", snap => {
      snap.val() && this.setState({ secretCode: snap.val().secretCode });
      //console.log("code:", this.state.secretCode);
    });

    this.addListeners();
  }

  //ハロリノから
  componentWillMount() {
    localStorage.getItem("myData") &&
      this.setState({
        myData: localStorage.getItem("myData")
      });
  }
  //ハロリノから
  componentWillUpdate() {
    // setter
    this.props.selectChannel &&
      localStorage.setItem("myData", this.props.selectChannel);
  }

  componentWillUnmount() {
    this.state.presenceChannelRef
      .child(`${this.state.previousChannel.id}/${this.state.user.displayName}`)
      .remove();
    this.state.isMounted = false;
    this.removeListeners();
  }

  addListeners = () => {
    let loadedChannels = [];
    this.state.channelsRef.on("child_added", snap => {
      loadedChannels.push(snap.val());
      this.setState({ channels: loadedChannels }, () => this.setFirstChannel());
      this.addNotificationListener(snap.key);
    });
  };

  addNotificationListener = channelId => {
    this.state.messagesRef.child(channelId).on("value", snap => {
      if (this.state.channel) {
        this.handleNotifications(
          channelId,
          this.state.channel.id,
          this.state.notifications,
          snap
        );
      }
    });
  };

  handleNotifications = (channelId, currentChannelId, notifications, snap) => {
    let lastTotal = 0;
    let index = notifications.findIndex(
      notification => notification.id === channelId
    );
    if (index !== -1) {
      if (channelId !== currentChannelId) {
        lastTotal = notifications[index].total;
        if (snap.numChildren() - lastTotal > 0) {
          notifications[index].count = snap.numChildren() - lastTotal;
        }
      }
      notifications[index].lastKnownTotal = snap.numChildren();
    } else {
      notifications.push({
        id: channelId,
        total: snap.numChildren(),
        lastKnownTotal: snap.numChildren(),
        count: 0
      });
    }
    if (this.state.isMounted) {
      this.setState({ notifications });
    }
  };

  removeListeners = () => {
    this.state.channelsRef.off();
  };

  setFirstChannel = () => {
    //const firstChannel = this.state.channels[0];

    //ハロリノから
    for (let channel of this.state.channels) {
      if (
        this.props.selectChannel === channel.id ||
        channel.id === this.state.myData
      ) {
        this.props.setCurrentChannel(channel);
        this.setActiveChannel(channel);
        this.addPresenceChannel(channel);
        this.setState({ channel: channel });
      }
    }

    //参加中 初期設定
    // firstChannel && this.addPresenceChannel(firstChannel);

    // if (this.state.firstLoad && this.state.channels.length > 0) {
    //   this.props.setCurrentChannel(firstChannel);
    //   this.setActiveChannel(firstChannel);
    //   this.setState({ channel: firstChannel });
    // }

    // this.setState({ firstLoad: false });
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  commaSplit = str => {
    let resArray = str.split(",");
    let arr = [];
    for (var i = 0; i < resArray.length; i++) {
      arr.push(resArray[i]);
    }

    return arr;
  };

  hasSecretCode(channleCode, userCode) {
    let secret_code = this.commaSplit(userCode);
    for (let i = 0; i < secret_code.length; i++) {
      if (channleCode === secret_code[i]) return true;
    }
    return false;
  }

  changeChannel = channel => {
    this.setActiveChannel(channel);
    this.state.channel &&
      this.state.typingRef
        .child(this.state.channel.id)
        .child(this.state.user.uid)
        .remove();
    this.addPresenceChannel(channel);

    this.clearNotifications();
    if (
      channel.visible === "show" ||
      (this.state.secretCode &&
        this.hasSecretCode(channel.secretCode, this.state.secretCode))
      //channel.secretCode === this.state.secretCode
    ) {
      this.props.setCurrentChannel(channel);
      this.props.setPrivateChannel(false);
      this.setState({ channel });
    }
  };

  clearNotifications = () => {
    let index = this.state.notifications.findIndex(
      notification => notification.id === this.state.channel.id
    );

    if (index !== -1) {
      let updatedNotifications = [...this.state.notifications];
      updatedNotifications[index].total = this.state.notifications[
        index
      ].lastKnownTotal;
      updatedNotifications[index].count = 0;
      this.setState({ notifications: updatedNotifications });
    }
  };

  setActiveChannel = channel => {
    this.setState({ activeChannel: channel.id });
  };

  getNotificationCount = channel => {
    let count = 0;
    this.state.notifications.forEach(notification => {
      if (notification.id === channel.id) {
        count = notification.count;
      }
    });
    if (count > 0) return count;
  };

  displayChannels = channels =>
    channels.length > 0 &&
    channels.visible !== "hide" &&
    channels.map(channel => (
      <Menu.Item
        key={channel.id}
        onClick={() => this.changeChannel(channel)}
        name={channel.name}
        style={{ opacity: 0.7 }}
        active={channel.id === this.state.activeChannel}
      >
        {this.getNotificationCount(channel) && (
          <Label color="red">{this.getNotificationCount(channel)}</Label>
        )}
        {/* # {channel.name} */}
        {this.isVisible(channel.visible, channel.name, channel.secretCode)}
      </Menu.Item>
    ));

  displaySingleChannels = channels =>
    channels.length > 0 &&
    channels.visible !== "hide" &&
    channels.map(
      channel =>
        this.isHelloRenoUser(channel) && (
          <Menu.Item
            key={channel.id}
            onClick={() => this.changeChannel(channel)}
            name={channel.name}
            style={{ opacity: 0.7 }}
            active={channel.id === this.state.activeChannel}
          >
            {this.getNotificationCount(channel) && (
              <Label color="red">{this.getNotificationCount(channel)}</Label>
            )}
            {/* # {channel.name} */}
            {this.isVisible(channel.visible, channel.name)}
          </Menu.Item>
        )
    );

  isFormValid = ({ channelName, channelDetails }) =>
    channelName && channelDetails;

  openModal = () => this.setState({ modal: true });

  closeModal = () => this.setState({ modal: false });

  isVisible = (visible, name) => {
    if (visible === "show") {
      return "#" + name;
    } else if (visible === "secret") {
      return "#" + name + "(秘密の部屋)";
    }
  };

  //部屋に参加中の人
  addPresenceChannel = channel => {
    const { presenceChannelRef, user } = this.state;
    this.setState({ previousChannel: channel });

    const newPresenceChannel = {
      avatar: user.photoURL
    };

    if (this.state.previousChannel.id) {
      // const oldRef = presenceChannelRef.child(this.state.previousChannel.id);
      // oldRef.remove();
      //console.log(user.uid);

      //var ref = firebase.database().ref("presenceChannel");
      presenceChannelRef
        .child(`${this.state.previousChannel.id}/${user.displayName}`)
        .remove();
    }

    if (user.displayName) {
      const newRef = presenceChannelRef
        .child(channel.id)
        .child(user.displayName);
      newRef.set(newPresenceChannel);
    }
  };

  isHelloRenoUser = channel => {
    //return this.props.selectChannel === channel.id;
    return (this.state.myData || this.props.selectChannel) === channel.id;
    //return this.hasSecretCode(channel.secretCode, this.state.secretCode);
  };

  isHelloRenoUser2 = channels => {
    channels.map(channel =>
      this.hasSecretCode(channel.id, this.state.secretCode) ? true : false
    );
  };
  render() {
    const {
      channelName,
      numUniqueUsers,
      handleSearchChange,
      searchLoading,
      isPrivateChannel,
      handleStar,
      isChannelStarred
    } = this.props;

    return (
      <Segment clearing>
        {/* Channel Title */}
        <Header fluid="true" as="h2" floated="left" style={{ marginBottom: 0 }}>
          <span className="headerTitle">
            {channelName}
            {/* 星アイコン */}
            {/* {!isPrivateChannel && (
              <Icon
                onClick={handleStar}
                name={isChannelStarred ? "star" : "star outline"}
                color={isChannelStarred ? "yellow" : "black"}
              />
            )} */}
          </span>
          {/* <Header.Subheader>{numUniqueUsers}</Header.Subheader> */}
        </Header>

        {/* Channel Search Input */}
        <Header floated="right" className="searchBar">
          <Input
            loading={searchLoading}
            onChange={handleSearchChange}
            size="mini"
            icon="search"
            name="searchTerm"
            placeholder="メッセージを検索する"
          />
        </Header>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  selectChannel: state.channel.selectChannel
});

export default connect(
  mapStateToProps,
  { setCurrentChannel, setPrivateChannel }
)(MessagesHeaderChannel);



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesHeaderChannel.js